import { useMemo, useState } from 'react';
import { type DataTableRowEventHandler, ErpDataTableV2 } from '@/components/custom/erp/data-table-v2';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import { invoiceDetailColumns, invoicePaymentAllocationColumns } from './cols-definition';
import { ErpInputTableV2 } from '@/components/custom/erp/input-table-v2';
import InitialSearchDialog from './components/tabs/InitialSearchDialog';
import { ActionBar } from './components/tabs/ActionBar';

const PhanBoTienHangTraChoCacHoaDonPage = () => {
  const [searchDialogOpen, setSearchDialogOpen] = useState(true);
  const [formMode, setFormMode] = useState<'add' | 'edit' | 'view'>('add');
  const [currentObj, setCurrentObj] = useState<MuaHangRecord | null>(null);
  const [selectedObj, setSelectedObj] = useState<MuaHangRecord | null>(null);
  const [mainRows] = useState<MuaHangRecord[]>([]);
  const isLoading = false;

  const handleSearchOpen = () => {
    setFormMode('add');
    setCurrentObj(null);
    setSearchDialogOpen(true);
  };

  const handleSearchClose = () => {
    setSearchDialogOpen(false);
  };

  const handleRefresh = () => {};

  const handlePinColumn = () => {};

  const handleSubmit = (_data: MuaHangRecord) => {
    setSearchDialogOpen(false);
  };

  const handleRowClick: DataTableRowEventHandler = params => {
    setSelectedObj(params.row);
  };

  const tables = useMemo(
    () => [
      {
        name: 'Tất cả',
        rows: mainRows.filter(row => row.disabled === '1'),
        columns: invoicePaymentAllocationColumns(),
        tabProps: { className: 'whitespace-nowrap' }
      }
    ],
    [mainRows]
  );

  return (
    <div className='flex h-screen w-full flex-col overflow-hidden'>
      {searchDialogOpen && (
        <InitialSearchDialog
          open={searchDialogOpen}
          formMode={formMode}
          initialData={currentObj}
          onClose={handleSearchClose}
          onSearch={handleSubmit}
        />
      )}

      <div className='flex h-full flex-col'>
        <ActionBar
          printedSample={[]}
          onCreate={handleSearchOpen}
          onSearch={handleSearchOpen}
          onRefresh={handleRefresh}
          onPinColumns={handlePinColumn}
          onPrintEditClick={() => {}}
          isEditDisabled={!selectedObj}
          className='border-b border-gray-200'
        />

        <ResizablePanelGroup direction='vertical' className='flex-1 overflow-hidden'>
          <ResizablePanel defaultSize={55} minSize={20}>
            <div
              data-perf-id='phan-bo-tien-hang-tra-cho-cac-hoa-don-master-table'
              className='h-full w-full overflow-hidden'
            >
              <ErpDataTableV2
                tables={tables}
                selectedRowId={selectedObj?.uuid || selectedObj?.id}
                onRowClick={handleRowClick}
                loading={isLoading}
              />
            </div>
          </ResizablePanel>

          <ResizableHandle withHandle className='bg-slate-200/80 hover:bg-slate-300' />

          <ResizablePanel defaultSize={45} minSize={20}>
            <div
              data-perf-id='phan-bo-tien-hang-tra-cho-cac-hoa-don-bottom-detail-table'
              className='h-full overflow-hidden'
            >
              <ErpInputTableV2
                rows={[]}
                columns={invoiceDetailColumns}
                showIndexColumn
                height='100%'
                loading={isLoading && !selectedObj}
              />
            </div>
          </ResizablePanel>
        </ResizablePanelGroup>
      </div>
    </div>
  );
};

export default PhanBoTienHangTraChoCacHoaDonPage;
